import { Component, EventEmitter, Input, Output, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ProveedorServicio } from 'src/app/global/interfaces/proveedor-servicios';
import { ProveedorServiceVM } from 'src/app/view-model/services/proveedor-vm.service';

@Component({
  selector: 'app-configura-proveedor-servicio-tecnologico',
  templateUrl: './configura-proveedor-servicio-tecnologico.component.html',
  styleUrls: ['./configura-proveedor-servicio-tecnologico.component.scss']
})
export class ConfiguraProveedorServicioTecnologicoComponent {

  proveedores: ProveedorServicio[] = [];
  filteredProveedores: ProveedorServicio[] = [];

  @Input() selectedPST:number;
  @Output() selectPSTEvent = new EventEmitter<number>();

  constructor(
    private proveedorServiceVM: ProveedorServiceVM,
    private sanitizer: DomSanitizer
  ) {
    this.obtenerProveedores();
  }

  async obtenerProveedores() {
    const proveedores = await this.proveedorServiceVM.getProveedores().toPromise();
    this.proveedores = this.shuffleProveedores(proveedores, this.selectedPST || null);
    this.assignCopy();
  }

  selectPST(idComercio) {
    this.selectedPST = idComercio;
    this.selectPSTEvent.emit(this.selectedPST);
  }

  transform(base64Img):string {
    return this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/jpg;base64,${base64Img}`));
  }

  filterProveedor(value) {
    this.selectPST(undefined);
    if (!value) {
      this.assignCopy();
    }
    this.filteredProveedores = Object.assign([], this.proveedores).filter(
      item => item.nombreFantasia.toLowerCase().indexOf(value.toLowerCase()) > -1
    )
  }

  private assignCopy() {
    this.filteredProveedores = Object.assign([], this.proveedores);
  }

  private shuffleProveedores(array: any[], idFirstElement?:number){
    let shuffledArray = array.sort(() => Math.random() - 0.5);
    if(idFirstElement){
      const foundIdx = shuffledArray.findIndex(el => el.idComercio == idFirstElement);
      const itemToFind = shuffledArray.find(el => el.idComercio == idFirstElement);
      shuffledArray.splice(foundIdx, 1);
      shuffledArray.unshift(itemToFind);
    }
    return shuffledArray;
  }
}
